import { Suspense, lazy } from 'react';

const AdminDetails = lazy(() => import('../components/Admin/AdminDetails'));

const AdminDetailsLazy: React.FC = () => {
    return <Suspense><AdminDetails/></Suspense>;
}

export default AdminDetailsLazy;